module.exports = __webpack_public_path__ + "static/media/VectorSmartObject.2f658a5b.png";